import request from '@/utils/request'

export function login(data) {
    return request({
        url: '/user/login',
        method: 'post',
        data
    })
}

export function getOpenId(data) {
    return request({
        url: '/user/getOpenId',
        method: 'get',
        params: data
    })
}

export function confirmLunHui(uid) {
    return request({
        url: '/task/confirmLunHui/'+ uid,
        method: 'get'
    })
}


export function rank(data) {
    return request({
        url: '/user/rank',
        method: 'get',
        params: data
    })
}

export function getTasks(data) {
    return request({
        url: '/task/getTasks',
        method: 'get',
        params: data
    })
}
export function checkTask(data) {
    return request({
        url: '/task/checkTask',
        method: 'post',
        data
    })
}
export function getDrink(data) {
    return request({
        url: '/task/getDrink',
        method: 'post',
        data
    })
}

export function redeemCoupon(data) {
    return request({
        url: '/coupon/redeemCoupon',
        method: 'post',
        data
    })
}

export function checkCoupon(data) {
    return request({
        url: '/coupon/checkCoupon',
        method: 'post',
        data
    })
}

export function getCouponList(data) {
    return request({
        url: '/coupon/list',
        method: 'get',
        params: data
    })
}

export function getCouponRedemptionList(data) {
    return request({
        url: '/coupon/redemption/list',
        method: 'get',
        params: data
    })
}

export function getLottery(data) {
    return request({
        url: '/task/getLottery',
        method: 'post',
        data
    })
}


export function upload(data) {
    return request({
        url: '/upload',
        method: 'post',
        params: data,
        headers: {
            'Content-Type': 'multipart/form-data' // 设置multipart/form-data
        }
    })
}

export function saveWechatMomentsTask(data) {
    return request({
        url: '/task/saveWechatMomentsTask',
        method: 'post',
        data
    })
}

export function getWechatMomentsTask(data) {
    return request({
        url: '/task/getWechatMomentsTask',
        method: 'get',
        params: data
    })
}




export function gaizhang(data) {
    return request({
        url: '/task/gaizhang',
        method: 'post',
        data
    })
}

export function getGift(data) {
    return request({
        url: '/user/getGift',
        method: 'post',
        data
    })
}

export function getStoreInfo(storeId) {
    return request({
        url: '/store/getStoreInfo/' + storeId,
        method: 'get',
    })
}

export function getBarHopping(data) {
    return request({
        url: '/user/getBarHopping',
        method: 'post',
        data
    })
}

export function recoverByTicketCode(data) {
    return request({
        url: '/user/recoverByTicketCode',
        method: 'post',
        data
    })
}

